/**
 * Supabase config — credentials must come from environment variables (never committed).
 */
export function getSupabaseConfig() {
  const url = process.env.REACT_APP_SUPABASE_URL?.trim() || '';
  const key = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim() || '';
  return {
    url,
    key,
    isConfigured: Boolean(url && key),
  };
}

/**
 * Public app origin for auth redirects (password reset, etc.).
 * Set REACT_APP_SITE_URL in production so reset emails never point at localhost.
 */
export function getSiteUrl() {
  const configured = process.env.REACT_APP_SITE_URL?.trim();
  if (configured) return configured.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return '';
}
